import {createSlice} from "@reduxjs/toolkit";
import {getSubscriptions} from './action'

const initialState = {
  state: {
    subscriptions: [],
    paging: null,
    detail: null
  },
  loading: true,
  error: ''
} as BaseState<SubscriptionState>

const slice = createSlice({
  name: 'subscriptionSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // summary
    builder.addCase(getSubscriptions.pending, (state) => ({
        ...state,
        loading: true
      }))
    builder.addCase(getSubscriptions.fulfilled, (state, action) => {
        const {items, paging} = action.payload
        return {
          state: {
            ...state.state,
            paging,
            subscriptions: items
          },
          error: null,
          loading: false
        }
      })
    builder.addCase(getSubscriptions.rejected, (state) => ({
        ...state,
        loading: true,
        error: 'Failed to get subscriptions'
      }))
  }
})

export default slice
